module.exports = __webpack_public_path__ + "img/CU.3625d5b1.svg";